var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"Logo"},[_c('img',{attrs:{"src":_vm.logo,"alt":"Hempel Yacht"},on:{"click":function($event){_vm.$router.push('/')}}})])}
var staticRenderFns = []

export { render, staticRenderFns }